import {
  AgregatRekap,
  DefinisiRekap,
  KolomRekap,
  NilaiRekap,
  RumusRekap
} from "@/services/LaporanKebidanan";

export function bagi(
  a: number | null,
  b: number | null,
  kali: number,
  desimal: number
): number | null {
  if (a === null || b === null || b === 0) return null;

  const p = Math.pow(10, desimal);
  const hasil = Math.floor((2 * a * kali * p + b) / (2 * b));

  return hasil / p;
}

function terapkan(
  rumus: RumusRekap,
  ambil: (kunci: string) => number | null
): number | null {
  if (rumus.op === "jumlah") {
    let total = 0;

    for (const k of rumus.kunci || []) {
      const v = ambil(k);
      if (v === null) return null;
      total += v;
    }

    return total;
  }

  const a = ambil(rumus.a || "");
  const b = ambil(rumus.b || "");

  if (a === null || b === null) return null;
  if (rumus.op === "kurang") return a - b;

  return bagi(a, b, 100, rumus.desimal === undefined ? 2 : rumus.desimal);
}

export function hitungNilai(
  definisi: Record<string, DefinisiRekap>,
  kolom: KolomRekap[],
  dasar: NilaiRekap
): NilaiRekap {
  const hasil: NilaiRekap = {};

  Object.keys(dasar).forEach(k => {
    hasil[k] = { ...dasar[k] };
  });

  const nilaiTurunan = (kunci: string, kolomId: string): number | null => {
    if (hasil[kunci] && kolomId in hasil[kunci]) return hasil[kunci][kolomId];

    const d = definisi[kunci];
    const v =
      d && d.rumus
        ? terapkan(d.rumus, k =>
            definisi[k] && definisi[k].jenis === "turunan"
              ? nilaiTurunan(k, kolomId)
              : hasil[k]
              ? hasil[k][kolomId]
              : null
          )
        : null;

    if (!hasil[kunci]) hasil[kunci] = {};
    hasil[kunci][kolomId] = v;

    return v;
  };

  kolom.forEach(k => {
    Object.keys(definisi).forEach(kunci => {
      if (definisi[kunci].jenis === "turunan") nilaiTurunan(kunci, k.id);
    });
  });

  return hasil;
}

export function hitungAkhir(
  definisi: Record<string, DefinisiRekap>,
  kolom: KolomRekap[],
  nilai: NilaiRekap,
  kunci: string,
  agregat: AgregatRekap
): number | null {
  const d = definisi[kunci];

  if (d && d.jenis === "turunan" && d.rumus) {
    return terapkan(d.rumus, k =>
      hitungAkhir(definisi, kolom, nilai, k, "jumlah")
    );
  }

  let jumlah: number | null = null;

  for (const k of kolom) {
    const v = nilai[kunci] ? nilai[kunci][k.id] : null;
    if (v !== null && v !== undefined) jumlah = (jumlah === null ? 0 : jumlah) + v;
  }

  if (agregat !== "rata") return jumlah;

  const berjalan = kolom.filter(k => k.berjalan).length;

  return jumlah === null || berjalan === 0 ? null : bagi(jumlah, berjalan, 1, 2);
}
